import {
  EZChat,
  EZChatProvider,
  EZChatControllerNew,
} from "@axl/ez-chat-for-school";
import "@axl/ez-chat-for-school/dist/ez-chat-for-school.css";
import { FC, useCallback, useMemo } from "react";

import { useDevice } from "@app/shared/lib/DeviceProvider";
import {
  useFileProvider,
  useLang,
  useLoc,
  useSdk,
  useSettings,
  useTokenStorage,
} from "@app/shared/lib/hooks";
import { ErrorBoundary } from "@app/shared/ui/ErrorBoundary";

export const Chat: FC = () => {
  const loc = useLoc();
  const fileProvider = useFileProvider();
  const settings = useSettings();
  const device = useDevice();
  const sdk = useSdk();
  const tokenStorage = useTokenStorage();

  const { lang } = useLang();

  const deviceStore = useMemo(
    () => ({
      height: device.height,
      deviceSize: device.deviceSize,
      isTouch: device.isTouch,
    }),
    [device.deviceSize, device.height, device.isTouch],
  );

  const handleChatController = useCallback(
    (controller: EZChatControllerNew) => {
      device.setChatController(controller);
    },
    [device.setChatController],
  );

  if (!tokenStorage.accessToken) return null;

  return (
    <ErrorBoundary fallback={null}>
      <EZChatProvider
        lang={lang}
        loc={loc}
        fileProvider={fileProvider}
        deviceStore={deviceStore}
        tokenStore={{ accessToken: tokenStorage.accessToken as string }}
        settings={settings.chat}
        fileApi={sdk.api.file}
      >
        <ErrorBoundary fallback={null}>
          <EZChat
            handler={handleChatController as any}
            defaultPosition={{ top: 70, right: 10 }}
            floating
          />
        </ErrorBoundary>
      </EZChatProvider>
    </ErrorBoundary>
  );
};
